import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import IndexBanner from "../IndexBanner";
import RaceEthnicityBarChartCard from "../charts/RaceEthnicityBarChartCard";
import MetricBarChart from "../charts/MetricBarChart";
import AgeByGenderChart from "../charts/AgeByGenderChart";

const DemographicMetrics = ({ indicators, metadata, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log('demo data:', sortedMetrics);

    const demoOne: DisaggregatedMetric[] = sortedMetrics[0];

    // Check if city lod Population metric is present, and filter out block group lod
    const hasCityPop = demoOne.some(metric => metric.id === 1184);
    const filteredDemoOne = hasCityPop ? demoOne.filter(metric => metric.id !== 1133) : demoOne;

    const demoTwo: DisaggregatedMetric[] = sortedMetrics[1];

    const race = indicators.find(i => i.id === 1134);
    const ethnicity = indicators.find(i => i.id === 1135);
    const immigration = indicators.find(i => i.id === 1182);
    const female = indicators.find(i => i.id === 1147);
    const male = indicators.find(i => i.id === 1148);

    let metricsForTab = indicators; // Get metrics for the current tab

    // Find the indexMetric from metadata based on the current tab
    const indexMetricId = metadata?.find((metric) => metric.metric_source_type === "index" && metric.metric_category.toLowerCase() === tab.toLowerCase())?.id || 0;

    // Find the full indicator object that matches indexMetric
    const indexMetricData = indicators.find(metric => metric.id === Number(indexMetricId)) || null;

    // Exclude the index metric from the list of metrics
    if (indexMetricId) {
        metricsForTab = metricsForTab.filter((metric) => metric.id !== indexMetricId);
    }

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    return (
        <div className="h-screen">
            <div className="mb-2">
                <IndexBanner
                    key={indexMetricId}
                    metric={indexMetricData}
                    svg={undefined}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>
            <p className="text-[10px] text-lacey-text mx-4">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
            </p>
            <p className="text-lacey-text mx-4 text-[10px]">Data updates published August 14, 2026.</p>
            
            <div className="mx-auto px-4 pb-8 pt-4">
                <p className="text-lacey-text ml-2 text-xs mb-2">Indicators shown below depict demographic details for the population within the selected area.</p>
                <div className="grid grid-cols-2 gap-4">
                    {filteredDemoOne.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}

                    <div className="col-span-2 w-full">
                        <RaceEthnicityBarChartCard raceMetric={race}ethnicityMetric={ethnicity} disaggData={indicators} geoDetails={geoDetails} geoTag={geoTag} selectionActive height="h-56" background="white" barColor="#00A18A"/>
                    </div>

                    {demoTwo.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}

                    <div className="col-span-2 w-full">
                        <MetricBarChart metric={immigration} disaggData={indicators} geoDetails={geoDetails} geoTag={geoTag} selectionActive height="h-40" barColor="#00A18A" background="white" topFive={true}/>
                    </div>

                    {female && male &&
                    <div className="w-full mt-2 col-span-2">
                        <AgeByGenderChart
                            maleMetric={male}
                            femaleMetric={female}
                            metadataMetricId={1147}
                            title="Age & Sex"
                            subtitle="Population distribution by age and sex"
                            maleColor="#00A18A"
                            femaleColor="#6FAEDE"
                            height="h-60"
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            showMetadataIcon={true}
                        />
                    </div>
                    }  
                </div>
            </div>
        </div>
    );
}

export default DemographicMetrics;